import { useConfig } from '@exam-management/configuration';
import { type UserAvatarProps, UserAvatar } from '@shared/components';
import { isInternalEmailDomain } from '@shared/utils';

type UserTypeAvatarProps = Omit<UserAvatarProps, 'primary'> & { email: string };

export default function UserTypeAvatar(props: Readonly<UserTypeAvatarProps>) {
  const { email, ...restProps } = props;
  const configuration = useConfig();

  const internalUserEmailDomains = configuration.modules.userManagement.internalUserEmailDomains;
  const isPrimary = isInternalEmailDomain(email, internalUserEmailDomains);

  return <UserAvatar variant='circular' primary={isPrimary} {...restProps} />;
}
